import React, { useState } from "react";
import Modal from "react-modal";
import { Checkbox } from "antd";
import { useDispatch, useSelector } from "react-redux";
import "./style.scss";
import { createNewsEventSubscriptionRequest } from "../../actions";
import { EVENT_THEMES, EVENT_TRIGGERS } from "../../DefaultValue/eventCatalog";

const EMAIL_PATTERN = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

// Sensible starting point for a fresh subscription: every theme, announced
// plus a week's notice. Matches the example in the API documentation.
const DEFAULT_TRIGGERS = ["WHEN_ANNOUNCED", "ONE_WEEK_BEFORE"];

export const ModalNewSubscription = ({
  isOpenModel,
  buttonCloseHandler,
  translation,
  themeLabels,
  fonts,
}) => {
  const dispatch = useDispatch();
  const language = useSelector(
    (state) => state.newsEventPage.subscription.language
  );

  const [email, setEmail] = useState("");
  const [themes, setThemes] = useState(EVENT_THEMES.map((theme) => theme.key));
  const [triggers, setTriggers] = useState(DEFAULT_TRIGGERS);
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [error, setError] = useState(null);

  const newsEvent = translation.newsEvent;

  const toggle = (list, setList) => (value) => (e) => {
    if (e.target.checked) {
      setList([...list, value]);
    } else {
      setList(list.filter((item) => item !== value));
    }
  };

  const checkValidation = (value) => {
    const valid = Boolean(value) && EMAIL_PATTERN.test(value);
    setIsValidEmail(valid);
    return valid;
  };

  // Checked here as well as server side so an empty selection gives immediate
  // feedback rather than a round trip that comes back 400.
  const subscribeAction = () => {
    if (!checkValidation(email)) return;
    if (!themes.length) {
      setError(newsEvent.validation.themes);
      return;
    }
    if (!triggers.length) {
      setError(newsEvent.validation.triggers);
      return;
    }
    setError(null);
    dispatch(
      createNewsEventSubscriptionRequest({
        email,
        themes,
        triggers,
        language,
        translation,
        fonts,
        onSuccess: buttonCloseHandler,
      })
    );
  };

  return (
    <div className="news-event-modal-root">
      <Modal
        ariaHideApp={false}
        isOpen={isOpenModel}
        onRequestClose={buttonCloseHandler}
        className="news-event-modal"
        overlayClassName="news-event-modal-overlay"
        contentLabel={translation.modalStrings.newSubscription}
      >
        <div className="news-event-modal-header">
          <span className="news-event-modal-title">
            {translation.modalStrings.newSubscription}
          </span>
          <img
            className="icon"
            alt="close"
            src="./icons/close.svg"
            onClick={buttonCloseHandler}
          />
        </div>

        <div className="news-event-modal-body">
          <span className="news-event-modal-intro">
            {newsEvent.modalStrings.subscribeToReceiveEvents}
          </span>

          <div className="news-event-modal-input-title">
            <span>{translation.personalDetail.email}</span>
            <span className="news-event-modal-star">*</span>
          </div>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.currentTarget.value)}
            onBlur={(e) => checkValidation(e.currentTarget.value)}
            className={
              isValidEmail
                ? "news-event-modal-input"
                : "news-event-modal-input-error"
            }
          />

          <div className="news-event-modal-section-title">
            <span>{newsEvent.eventPreferences.eventTypes}</span>
          </div>
          <div className="news-event-modal-checkboxes">
            {EVENT_THEMES.map((theme) => (
              <div className="news-event-modal-checkbox-item" key={theme.key}>
                <Checkbox
                  checked={themes.includes(theme.key)}
                  onChange={toggle(themes, setThemes)(theme.key)}
                />
                <span>{themeLabels[theme.key] || theme.value}</span>
              </div>
            ))}
          </div>

          <div className="news-event-modal-section-title">
            <span>{newsEvent.titles.notificationTimingTitle}</span>
          </div>
          <div className="news-event-modal-checkboxes">
            {EVENT_TRIGGERS.map((trigger) => (
              <div className="news-event-modal-checkbox-item" key={trigger}>
                <Checkbox
                  checked={triggers.includes(trigger)}
                  onChange={toggle(triggers, setTriggers)(trigger)}
                />
                <span>{newsEvent.triggers[trigger].title}</span>
              </div>
            ))}
          </div>

          {error && <div className="news-event-modal-error">{error}</div>}

          <div className="news-event-modal-note">
            <span>{newsEvent.modalStrings.youMayManageAll}</span>
          </div>
        </div>

        <div className="news-event-modal-bottom">
          <button className="news-event-modal-button" onClick={subscribeAction}>
            {translation.modalStrings.subscribe}
          </button>
        </div>
      </Modal>
    </div>
  );
};
